module.exports = __webpack_public_path__ + "static/media/net.1e004593.jpg";